import React, { useEffect, useState } from "react";
import "./Banner.css"
import axios from "../../axios";
import {ImgUrl,API_KEY} from '../../constants/Constants';



function Banner() {
  
  const [counter, setCounter] = useState(0);
  const [movie,setMovie] = useState([]);
  useEffect(()=>{
    axios.get(`trending/all/week?api_key=${API_KEY}&language=en-US`).then((response)=>{
      //console.log(response.data.results[0]);
      setMovie(response.data.results[counter]);
    })
  },[counter])

  function click(){
    setCounter(counter + 1);
  }
  

  return( 
   
  <div 
  style={{backgroundImage: `url(${movie ? ImgUrl+movie.backdrop_path : ""})`}} onClick={click}  className="banner">
    <div className="content">
    <h1 className="title">{movie.title? movie.title : "Movie Title"}</h1>
    <div className="banner_button">
        <button className="button">Play</button>
        <button className="button">My List</button>
    </div>
    <h1 className="discription">{movie? movie.overview : "title"}</h1>
    </div>  
    <div className="fade_bottom"></div>    
  </div>
  )
}

export default Banner;
